import { Link } from "react-router-dom";

export default function DestinationCard({ dest, className = "" }) {
  return (
    <Link
      to={`/destinations/${dest.slug}`}
      data-testid={`destination-card-${dest.slug}`}
      className={`relative block overflow-hidden group border border-[#d4af37]/30 hover:border-[#d4af37]/70 transition-all ${className}`}
    >
      {/* in-flow aspect spacer holds the image and gives the card height */}
      <div className="relative w-full aspect-[3/4]">
        <img src={dest.banner_image} alt={dest.name} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1400ms]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2d1616]/85 via-[#2d1616]/20 to-transparent" />
        <div className="absolute top-3 right-3 w-9 h-9 border-t border-r border-[#d4af37]" />
        <div className="absolute bottom-3 left-3 w-9 h-9 border-b border-l border-[#d4af37]" />
        <div className="absolute inset-0 flex flex-col justify-end p-5 sm:p-6 text-white">
          {dest.region && <div className="text-[10px] tracking-[0.26em] uppercase text-[#e8c970] mb-1.5">{dest.region}</div>}
          <div className="font-serif text-3xl sm:text-4xl leading-none">{dest.name}</div>
          <div className="mt-3 inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            Explore <span className="w-6 h-px bg-[#d4af37]" />
          </div>
        </div>
      </div>
    </Link>
  );
}
